import { Button } from '@/ui/design-system/components/ui/button';
import { FiCheck } from 'react-icons/fi';
import { cn } from '@/ui/design-system/utils/cn';
import { forwardRef } from 'react';

const FilterCheckbox = forwardRef(
    (
        {
            checked,
            onChange,
            children,
            preserveIconSpace = true,
            isLoading,
            className,
            ...props
        },
        ref,
    ) => {
        if (isLoading) {
            return (
                <div
                    className={cn(
                        'min-w-32 h-9 rounded-md shimmer bg-muted',
                        className,
                    )}
                />
            );
        }

        return (
            <Button
                ref={ref}
                type="button"
                role="switch"
                aria-checked={checked}
                variant={checked ? 'default' : 'outline'}
                size="default"
                onClick={() => onChange(!checked)}
                className={cn(
                    'capitalize',
                    checked &&
                        'bg-primary/10 text-foreground hover:bg-primary/15',
                    className,
                )}
                {...props}
            >
                {children}
                {(checked || preserveIconSpace) && (
                    <FiCheck
                        className={cn(
                            'ml-auto shrink-0 text-primary',
                            !checked && 'opacity-0',
                        )}
                        aria-hidden={true}
                    />
                )}
            </Button>
        );
    },
);

export default FilterCheckbox;
